import { render, staticRenderFns } from "./StaffPermission.vue?vue&type=template&id=73094919"
import script from "./StaffPermission.vue?vue&type=script&lang=js"
export * from "./StaffPermission.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports